import { render, staticRenderFns } from "./BTextarea.vue?vue&type=template&id=ed3bfe04&scoped=true"
import script from "./BTextarea.vue?vue&type=script&lang=js"
export * from "./BTextarea.vue?vue&type=script&lang=js"
import style0 from "./BTextarea.vue?vue&type=style&index=0&id=ed3bfe04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3bfe04",
  null
  
)

export default component.exports